import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { SideMenuFilterItem } from '@vlabs/monokit/shared/ui/side-menu-filter-item';

import { DateFilterPopover, FaceIdsFilterPopover, UserDataFilterPopover } from './popovers';

const withLeftPopover = withPopover({ placement: 'left' });

const withSideMenuItemLeftPopover = withLeftPopover(SideMenuFilterItem);

export const DateFilterWithLeftPopover = withSideMenuItemLeftPopover(DateFilterPopover);
export const FaceIdsFilterWithLeftPopover = withSideMenuItemLeftPopover(FaceIdsFilterPopover);
export const UserDataFilterWithLeftPopover = withSideMenuItemLeftPopover(UserDataFilterPopover);
